import React from 'react';
import {FieldViewSize} from "../../../../const";
import {FieldEditableValueNotEmptyProps} from "../../../../proto/components/editable/value-not-empty";

export default function FieldDropdown_InlineValueEmpty(props:FieldEditableValueNotEmptyProps) {

    const size = _.get(props, 'size', FieldViewSize.DEFAULT)

    const classes = Classes("ui5-field-dropdown-inline-editable min-w-125", props.className, {
        'ui5-txt-no-accent-default'     : size === FieldViewSize.DEFAULT,
        'ui5-txt-no-accent-small'       : size === FieldViewSize.SMALL,
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {props.field.placeholder}
            </div>
            {props.children}
        </React.Fragment>
    )

}

